const emptyCampaign = {
    name: "",
    id: 0
};

export {
    emptyCampaign
}